import { IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';
import { DisplayIconFactory } from './display-icon-factory.interface';
import { ICardDataViewModel } from '@caslink/device-client/ng-app/shared/models/models';

export class GeneralDisplayIconFactory implements DisplayIconFactory {
    public createDisplayIcon(item: ICardDataViewModel): IDisplayInfoIcon {
        return {
            getLabelText: () => item.displayValue || item.name,
            getUnits: () => {
                if (item && item.numberSensorInputMap) {
                    return item.numberSensorInputMap.units;
                }
                return '';
            },
            icon: item.graphicBehavior as string,
            isLabelVisible: () => true,
            getValue: () => item.displayValue || item.value
        };
    }
}
